import { SelectionData } from '../../models/util.model'
import {
  LocationType,
  LocationUpdateSubject,
} from '../locations/location.model'

export const LOCATION_TYPES = [
  {
    code: LocationType.pick,
    name: 'Picking',
    icon: 'fad fa-hand-holding-box',
  },
  {
    code: LocationType.stock,
    name: 'Stock',
    icon: 'fad fa-box-up',
  },
  {
    code: LocationType.tote,
    name: 'Totes',
    icon: 'fad fa-box-full',
  },
  {
    code: LocationType.ticketPallet,
    name: 'Ticket pallet',
    icon: 'fad fa-pallet-box',
  },
  {
    code: LocationType.scrap,
    name: 'Scrapped',
    icon: 'fad fa-bone-break',
  },
]

export const LOCATION_BULK_SUBJECTS: SelectionData<LocationUpdateSubject>[] = [
  {
    label: 'Tipologia',
    value: 'TYPE',
    icon: 'fad fa-inventory',
  },
  {
    label: 'Modello',
    value: 'MODEL',
    icon: 'fad fa-ruler-combined',
  },
  {
    label: 'Abilitazione prelievo',
    value: 'IS_PLACED',
    icon: 'fad fa-low-vision',
  },
  {
    label: 'Per invendibili',
    value: 'FOR_SCRAPS',
    icon: 'fad fa-fragile',
  },
]
